__webpack_require__.p = "https://caracalui.beta.us-east-1.urc.advertising.amazon.dev/";